import { Body, Controller, Get, Param, Patch, Post } from '@nestjs/common';
import {  ApiOperation, ApiTags } from '@nestjs/swagger';
import { CustomerService } from '../../../database/services/customer/customer.service';



@ApiTags('customer')
@Controller('v1/customer')
export class CustomerController {

    constructor(
        private customerService:CustomerService,
      ) {}

   
    @ApiOperation({ summary: 'Get all customers'})
    @Get('')
    getCustomers(): object {
      return this.customerService.getCustomers()
    }

    @ApiOperation({ summary: 'Create new customer'})
    @Post('')
    createCustomer(@Body()params): object {
      return this.customerService.createCustomer(params)
    }

    @ApiOperation({ summary: 'Update customer'})
    @Patch(':id')
    async updateCustomer(@Body()body,@Param()params): Promise<object> {
     
      let s =await  this.customerService.updateCustomer(body,params)
      return  s
    }
    

   
  

}
